const FCM_TOKEN_KEY = 'ndx_fcm_token';
const DEVICE_ID_KEY = 'inspection_deviceId';
const USER_TOKEN_KEY = 'ndx_user_token';
const CURRENT_FBO_KEY = 'current-fbo';
const OUT_OF_SERVICE_KEY = 'out_of_service';

export const getUserToken = () => localStorage.getItem(USER_TOKEN_KEY);

export const setUserToken = (token) => {
  localStorage.setItem(USER_TOKEN_KEY, token);
};

export const removeUserToken = () => {
  localStorage.removeItem(USER_TOKEN_KEY);
};

export const getCurrentFbo = () => localStorage.getItem(CURRENT_FBO_KEY);

export const setCurrentFbo = (id) => {
  const normalized = id === undefined ? null : id;
  localStorage.setItem(
    CURRENT_FBO_KEY,
    normalized === null ? String(null) : String(normalized),
  );
};

export const removeCurrentFbo = () => {
  localStorage.removeItem(CURRENT_FBO_KEY);
};

export const removeCurrentFboAll = () => {
  removeCurrentFbo();
};

export const getFCMToken = () => {
  let token = localStorage.getItem(FCM_TOKEN_KEY);
  return token;
}
 
export const setFCMToken = (token) => {
  localStorage.setItem(FCM_TOKEN_KEY, token);
}

export const removeFCMToken = () => {
  localStorage.removeItem(FCM_TOKEN_KEY);
  localStorage.removeItem(DEVICE_ID_KEY);

}

export const getOutOfServiceModalStatus = () => localStorage.getItem(OUT_OF_SERVICE_KEY);

export const setOutOfServiceModalStatus = (value) => {
  localStorage.setItem(OUT_OF_SERVICE_KEY, value);
}

export const removeOutOfServiceModalStatus = () => {
  localStorage.removeItem(OUT_OF_SERVICE_KEY);
}